module.exports = __webpack_public_path__ + "static/media/MHRP25N0002.e5d14ce5.svg";